function initState(state) {
    return state ? state : {};
}

module.exports = {
    initState: initState
};
